import { SynthBaseUI } from "./SynthUI";

export const SynthWamUI = ({instrument}) => {
    return (
        <SynthBaseUI instrument={instrument} synthesisParams={[["osc_octave", "fx_distortion_amount"], ["lfo_rate", "lfo_depth"]]}/>
    )
};